module.exports = {"411329001":"汉城街道","411329002":"汉华街道","411329101":"王庄镇","411329102":"沙堰镇","411329103":"新甸铺镇","411329104":"施庵镇","411329105":"歪子镇","411329106":"五星镇","411329107":"溧河铺镇","411329108":"王集镇","411329300":"城郊乡","411329303":"前高庙乡","411329305":"樊集乡","411329307":"上庄乡","411329309":"上港乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411329.json
// module id = 1506
// module chunks = 0